<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="bullet-detail"
      :title="editType === 'phone' ? $lang('修改手机号') : $lang('修改代收货款')"
    >
      <div class="dialog-content">
        <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
          <div v-if="editType === 'phone'">
            <h3>{{ $lang('收件人信息') }}</h3>
            <div class="group-content">
              <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
                <BasePhoneInput :value="phoneVal2" v-model="formData.receiverMobilePhone"></BasePhoneInput>
              </el-form-item>
              <el-form-item :label="$lang('收件人备用手机号码')" prop="receiverTelphone">
                <BasePhoneInput :value="receiverTelphone" v-model="formData.receiverTelphone"></BasePhoneInput>
              </el-form-item>
            </div>
          </div>
          <div v-else>
            <h3>{{ $lang('代收货款信息') }}</h3>
            <div class="group-content">
              <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
                <el-select v-model="formData.codCurrencyTypeName" @change="changeCodCurrency" :disabled="true">
                  <el-option v-for="item in codCurrencyType" :key="item.code" :label="item.code" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
                <el-input
                  v-model="formData.codMoney"
                  :disabled="codDisabled"
                  :label="$lang('描述文字')"
                  :placeholder="$lang('请输入对应的金额')"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  @blur="getCalcHandler"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$lang('代收货款手续费')" prop="codFee">
                <el-input v-model="formData.codFee" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12" :disabled="true"></el-input>
              </el-form-item>
            </div>
            <div class="tips" style="margin-top: 15px"><i style="margin-right: 5px; color: #f5222d">*</i>{{ $lang('代收货款修改需要审核通过后才会更改') }}</div>
          </div>
        </el-form>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button class="h40" @click="viewDialogVisible = false">{{ $lang('取 消') }}</el-button>
        <el-button type="primary" :loading="keyBtn" @click="editSave" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getsysCurrencyType, getCalc } from '@api/module/customer'
import { RULES, phoneAndMobile } from '@utils/rules'

export default {
  name: 'WaybillEdit',
  props: {
    rowData: {
      type: Object,
      default: _ => { },
    },
    editType: {
      type: String,
      default: 'phone',
    },
    waybillLogStatus: {
      type: String,
      default: '',
    },
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    codDisabled () {
      // const codMoney = this.rowData.codMoney
      const waybillLogStatus = +this.waybillLogStatus
      const flag = (waybillLogStatus === 102) || this.rowData.expressTypeCode === 'DR'
      // const flag = !codMoney || (codMoney === 0) || waybillLogStatus === 102
      // console.log(codMoney, waybillLogStatus, flag)
      return flag
    },
  },
  watch: {
    rowData: {
      handler (val) {
        const { waybillNo, receiverMobilePhone, receiverTelphone, codMoney, codFee, expressTypeCode } = val
        this.formData = {
          ...this.formData,
          receiverMobilePhone,
          receiverTelphone,
          codCurrencyTypeName: (this.codCurrencyType[0] ? this.codCurrencyType[0].code : ''),
          codMoney,
          codFee,
          waybillNo,
        }
        if (expressTypeCode === 'DR') this.formData.codMoney = ''
        console.log(val, 'after---->>', this.formData)
      },
      immediate: true,
      deep: true,
    },
    async 'formData.codMoney'(val) {
      // debugger
      const { codMoney } = this.formData
      const { codMaxAmount, isOpenCod } = this.userInfo
      if (parseFloat(codMoney) > 0) {
        if (isOpenCod === 2) {
          this.$message.error(this.$lang(`未开通COD`))
          this.formData.codMoney = ''
          return
        } else if ((parseFloat(codMoney) > parseFloat(codMaxAmount))) {
          this.$message.error(`${this.$lang('代收货款不能超过')}${codMaxAmount}! ${this.$lang('请重新输入')}`)
          this.formData.codMoney = ''
          return
        } else if (parseFloat(codMoney) > 99999.9) {
          this.$message.error(this.$lang('代收货款不能超过99999.9！请重新输入'))
          this.formData.codMoney = ''
          return
        } else if (toString(codMoney).indexOf('.') !== -1 && codMoney.split('.').length > 2) {
          this.$message.error(this.$lang('代收货款不能有多个小数点！请重新输入'))
          this.formData.codMoney = ''
          return
        } else if (toString(codMoney).indexOf('.') !== -1 && codMoney.split('.')[1].length > 1) {
          this.$message.error(this.$lang('代收货款不能超过一位小数！请重新输入'))
          this.formData.codMoney = ''
          return
        }
        const codFeeParam = { collectionfee: codMoney }
        const res = await getCalc(codFeeParam)
        Object.assign(this.formData, { codFee: (res.data !== undefined && res.data !== null ? res.data : 0) })
      } else {
        this.formData.codMoney = ''
        this.formData.codFee = ''
      }
    }
  },
  data () {
    return {
      viewDialogVisible: false,
      codCurrencyType: [],
      formData: {
        receiverMobilePhone: '',
        receiverTelphone: '',
        codCurrencyTypeName: '',
        codMoney: '',
        codFee: '',
      },
      rules: {
        receiverMobilePhone: [RULES.required, RULES.lengthEleven, { validator: phoneAndMobile }],
        receiverTelphone: [RULES.lengthEleven, { validator: phoneAndMobile }],
      },
      phoneVal2: '',
      receiverTelphone: '',
      keyBtn: false,
    }
  },
  created () {
    this.getCurrencyTypeList()
  },
  methods: {
    showDialog () {
      this.viewDialogVisible = true
    },
    hideDialog () {
      this.viewDialogVisible = false
    },
    async editSave () {
      await this.$refs.sizeForm.validate()
      if (parseFloat(this.formData.codMoney) >= 0) {
        this.keyBtn = true
        const params = {
          ...this.formData,
          beforeCodMoney: +this.rowData.codMoney,
          afterCodMoney: +this.formData.codMoney,
        }
        this.$emit('saveHandler', params, cb => {
          cb && this.hideDialog()
        })
        setTimeout(() => {
          this.keyBtn = false
        }, 800)
      } else {
        this.$message.error(this.$lang('代收货款金额不能为空'))
      }
    },
    async getCalcHandler () {
      if (parseFloat(this.formData.codMoney) > 0) {
        const res = await getCalc({ collectionfee: this.formData.codMoney })
        if (res && res.succ) {
          this.formData.codFee = res.data
        } else {
          this.$message.error(res.msg)
        }
      } else {
        this.formData.codFee = 0
      }
    },
    // 获取币别
    async getCurrencyTypeList () {
      const { data, succ, msg } = await getsysCurrencyType()
      if (succ) {
        this.codCurrencyType = data
        this.formData.codCurrencyTypeCode = data[0].code
        this.formData.codCurrencyTypeName = data[0].name
      } else {
        this.$message.error(msg)
      }
    },
    findDataObj (arr, val, key = 'id') {
      return arr.find(item => item[key] === val)
    },
    changeCodCurrency (val) {
      const obj = this.findDataObj(this.codCurrencyType, val, 'code')
      this.formData.codCurrencyTypeCode = obj.code
      this.formData.codCurrencyTypeName = obj.name
    },
  },
}
</script>
<style lang="scss">
.el-dialog__wrapper.bullet-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 650px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;
}
</style>
